import { doc, onSnapshot } from "firebase/firestore";
import { db } from 'xAppLib/providers/firestore.js';

const COLLECTION = 'online_users'

const DEBUG = false

export function watch_user_device(tenantId, uid, dvc, ca) {
    DEBUG && console.log("watch_user_device",uid,dvc, ca)
    const unsub = onSnapshot(doc(db, COLLECTION, tenantId ?? 'default', 'users', uid), (doc) => {
        if (DEBUG) {
            const source = doc.metadata.hasPendingWrites ? "Local" : "Server";
            console.log(source, " data: ", doc.data());
        }
        const data = doc.data()
        ca(data?.dvc?.[dvc],data?.revoked)
        },
        (error)=>{
            console.error(error)
        }
    
    );

    return unsub
}

export function watch_user_devices(tenantId, uid, onData, onError) {
	const docRef = doc(db, COLLECTION, tenantId ?? 'default', 'users', uid);

	return onSnapshot(docRef, snap => onData(snap.exists() ? snap.data() : null), onError);
}